<template>
  <div class="layout-main-top-wrapper">
    <div class="columns first-row is-mobile scrollable-zone" :style="firstRowStyle">
      <div class="column is-12">
        <div :style="firstColumnStyle" class="column-wrapper">
          <Zone name="main"></Zone>
        </div>
      </div>
    </div>
    <div class="columns second-row is-mobile scrollable-zone" :style="secondRowStyle">
      <div class="column is-12">
        <div :style="secondColumnStyle" class="column-wrapper">
          <Zone name="bottom"></Zone>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Zone from '@/components/Zone'

export default {
  name: 'LayoutTopbottom',
  components: { Zone },
  computed: {
    firstRowStyle () {
      const res = {}
      let percentage = this.$store.state.layout.attributes.mainHeightPercentage
      if (!percentage) {
        percentage = 50
      }
      res.height = percentage.toString() + '%'
      return res
    },
    firstColumnStyle () {
      const res = {}
      const paddingtop = this.$store.state.layout.attributes.paddingtop
      if (paddingtop === undefined) {
        res['padding-top'] = '80px'
      } else {
        res['padding-top'] = paddingtop
      }
      const paddingleft = this.$store.state.layout.attributes.paddingleft
      if (paddingleft !== undefined) {
        res['padding-left'] = paddingleft
      }
      const paddingright = this.$store.state.layout.attributes.paddingright
      if (paddingright !== undefined) {
        res['padding-right'] = paddingright
      }
      return res
    },
    secondRowStyle () {
      const res = {}
      let percentage = this.$store.state.layout.attributes.mainHeightPercentage
      if (!percentage) {
        percentage = 50
      } else {
        percentage = 100 - percentage
      }
      res.height = percentage.toString() + '%'
      return res
    },
    secondColumnStyle () {
      const res = {}
      const paddingbottom = this.$store.state.layout.attributes.paddingbottom
      if (paddingbottom === undefined) {
        res['padding-top'] = '80px'
      } else {
        res['padding-top'] = paddingbottom
      }
      return res
    }
  }
}
</script>

<style scoped lang="sass">
  .layout-main-top-wrapper
    position: fixed
    width: 100%
    height: 100%

  .second-row
    position: fixed
    bottom: 0
    left: 0
    right: 0
    overflow: hidden
    margin-bottom: 0px !important

  .first-row
    overflow: auto

  .column
    height: 100%
    padding: 0

  .column-wrapper
    height: 100%
    box-sizing: border-box

  .columns
    margin: 0px
</style>
